module.exports = __webpack_public_path__ + "media/left-arrow-circle.b68b2548.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/left-arrow-circle.png
// module id = 25
// module chunks = 0